module Cfnc
{
    "use strict";

    export interface IloadSavedModalScope extends ng.IScope
    {
        vm: IloadSavedModal;
        selectSearch: ( selectedsearch: string ) => void;
        cancel: () => void;
        savedSearches: SavedSearch[];
        //selectSearch: () => void;
    }

    export interface IloadSavedModal { }

    export class LoadSavedModalCtrl implements IloadSavedModal
    {
        static controllerId: string = 'loadSavedModalCtrl';
        private log;
        

        constructor( private common: ICommonFactory, private $scope: IloadSavedModalScope, private $modalInstance: ng.ui.bootstrap.IModalServiceInstance, savedSearch: Cfnc.SavedSearch[] )
        {
            this.log = common.logger.getLogFn( LoadSavedModalCtrl.controllerId );
            this.$scope.cancel = () => this.cancel();
            this.$scope.savedSearches = savedSearch;
            this.$scope.selectSearch = ( selectedsearch: string ) => this.selectSearch( selectedsearch);
        }

        selectSearch( selectedsearch: string)
        {
            this.$modalInstance.close( selectedsearch );
        }

        cancel()
        {
            this.$modalInstance.dismiss();
        }

        activate()
        {
            var promises = [];
            this.common.activateController( promises, LoadSavedModalCtrl.controllerId ).then( () =>
            {
                this.log( "Activated Modal" );
            });
        }
    }    
} 